<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Rodízio de placas"
          buttonText="Novo rodízio"
          :buttonFunction="openAddModel"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md4 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="schemes"
          :search="search"
          class="elevation-1 mt-2"
          no-data-text="Nenhum rodízio cadastrado"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:[`item.holiday_exempt`]="{ item }">
            {{ item.holiday_exempt ? 'SIM' : 'NÃO' }}
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <ActionButton
              message="Editar rodízio"
              icon="edit"
              @onclick="editItem(item)"
            />

            <ActionButton
              message="Excluir rodízio"
              icon="delete"
              color="error"
              @onclick="deleteItem(item.id)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- MODAL NOVO RODÍZIO -->
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="add_scheme" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{
                this.scheme.id ? 'Editar Esquema' : 'Novo Esquema'
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm2>
                    <v-text-field
                      label="Estado"
                      v-model="scheme.state"
                      :rules="[v => !!v || 'Campo obrigatório!']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm10>
                    <v-text-field
                      label="Cidade"
                      v-model="scheme.city"
                      :rules="[v => !!v || 'Campo obrigatório!']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-checkbox
                      v-model="scheme.holiday_exempt"
                      label="Rodízio isento em feriados"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex sm12>
                    <div style="display: flex; flex: 1; flex-direction: row">
                      <p style="margin: 0 0 5px 0">Dia da Semana</p>
                      <p style="margin: 0 0 5px 20px">Final da Placa</p>
                    </div>
                  </v-flex>
                  <div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">DOM</p> </v-flex>
                      <div v-for="(item, index) in sunday" :key="'sun' + index">
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="sunday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(sunday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(sunday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">SEG</p> </v-flex>
                      <div v-for="(item, index) in monday" :key="'mon' + index">
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="monday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(monday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(monday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">TER</p> </v-flex>
                      <div
                        v-for="(item, index) in tuesday"
                        :key="'tue' + index"
                      >
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="tuesday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(tuesday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(tuesday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">QUA</p> </v-flex>
                      <div
                        v-for="(item, index) in wednesday"
                        :key="'wed' + index"
                      >
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="wednesday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(wednesday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(wednesday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">QUI</p> </v-flex>
                      <div
                        v-for="(item, index) in thursday"
                        :key="'thu' + index"
                      >
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="thursday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(thursday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(thursday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">SEX</p> </v-flex>
                      <div v-for="(item, index) in friday" :key="'fri' + index">
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="friday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(friday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(friday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                    <div class="week_day">
                      <v-flex sm2> <p style="margin: 0">SAB</p> </v-flex>
                      <div
                        v-for="(item, index) in saturday"
                        :key="'sat' + index"
                      >
                        <v-flex sm2 style="max-width: none">
                          <v-select
                            v-model="saturday[index]"
                            :items="plateEnds"
                            class="plate_select"
                          >
                          </v-select>
                        </v-flex>
                      </div>
                      <v-flex sm2>
                        <div class="plate-buttons">
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="addPlate(saturday)"
                          >
                            +
                          </v-btn>
                          <v-btn
                            icon
                            color="blue darken-1"
                            v-on:click="removePlate(saturday)"
                          >
                            -
                          </v-btn>
                        </div>
                      </v-flex>
                    </div>
                  </div>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="add_scheme = false"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click="save()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import LicensePlateRotationSchemaController from '../../controllers/LicensePlateRotationSchemeController';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    ActionButton,
    TitleWithButton,
  },
  created() {
    this.getSchemes();
  },

  data() {
    return {
      plateEnds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      licensePlateRotationSchemaController: new LicensePlateRotationSchemaController(
        this.$resource
      ),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      headers: [
        { text: 'Estado', value: 'state' },
        { text: 'Cidade', value: 'city' },
        { text: 'Isento em Feriados', value: 'holiday_exempt' },
        { text: 'DOM', value: 'sunday' },
        { text: 'SEG', value: 'monday' },
        { text: 'TER', value: 'tuesday' },
        { text: 'QUA', value: 'wednesday' },
        { text: 'QUI', value: 'thursday' },
        { text: 'SEX', value: 'friday' },
        { text: 'SAB', value: 'saturday' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      scheme: {},
      schemes: [],
      add_scheme: false,

      sunday: [null],
      monday: [null],
      tuesday: [null],
      wednesday: [null],
      thursday: [null],
      friday: [null],
      saturday: [null],
    };
  },
  methods: {
    addPlate(day) {
      day.push(null);
    },

    removePlate(day) {
      if (day.length === 0) return;
      day.pop();
    },

    validateScheme(mode) {
      this.scheme.sunday = this.sunday[0] ? this.sunday : null;
      this.scheme.monday = this.monday[0] ? this.monday : null;
      this.scheme.tuesday = this.tuesday[0] ? this.tuesday : null;
      this.scheme.wednesday = this.wednesday[0] ? this.wednesday : null;
      this.scheme.thursday = this.thursday[0] ? this.thursday : null;
      this.scheme.friday = this.friday[0] ? this.friday : null;
      this.scheme.saturday = this.saturday[0] ? this.saturday : null;

      if (this.scheme.state === undefined || this.scheme.state === '') {
        this.$awn.alert('O campo estado é obrigatório!');
        return false;
      }
      if (this.scheme.city === undefined || this.scheme.city === '') {
        this.$awn.alert('O campo cidade é obrigatório!');
        return false;
      }
      if (
        this.schemes.find(item => item.city == this.scheme.city) &&
        mode === 'create'
      ) {
        this.$awn.alert(
          `O rodízio para a cidade ${this.scheme.city} já foi cadastrado!`
        );
        return false;
      }
      if (
        this.scheme.sunday === null &&
        this.scheme.monday === null &&
        this.scheme.tuesday === null &&
        this.scheme.wednesday === null &&
        this.scheme.thursday === null &&
        this.scheme.friday === null &&
        this.scheme.saturday === null
      ) {
        this.$awn.alert(
          'Ao menos um dia da semana deve possuir esquema de rodízio de placas!'
        );
        return false;
      }

      return true;
    },

    getSchemes() {
      this.licensePlateRotationSchemaController
        .getAll()
        .then(res => (this.schemes = res));
    },

    editItem(item) {
      this.scheme = Object.assign({}, item);

      this.sunday = this.scheme.sunday ? this.scheme.sunday : [null];
      this.monday = this.scheme.monday ? this.scheme.monday : [null];
      this.tuesday = this.scheme.tuesday ? this.scheme.tuesday : [null];
      this.wednesday = this.scheme.wednesday ? this.scheme.wednesday : [null];
      this.thursday = this.scheme.thursday ? this.scheme.thursday : [null];
      this.friday = this.scheme.friday ? this.scheme.friday : [null];
      this.saturday = this.scheme.saturday ? this.scheme.saturday : [null];

      this.add_scheme = true;
    },

    deleteItem(id) {
      this.licensePlateRotationSchemaController
        .delete(id)
        .then(res => {
          this.getSchemes();
          this.$awn.success('Esquema de rodízio deletado com sucesso.');
        })
        .catch(e => {
          this.$awn.alert('Erro ao deletar esquema de rodízio.');
        });
    },

    update() {
      if (!this.validateScheme('update')) return;
      this.licensePlateRotationSchemaController
        .update(this.scheme)
        .then(res => {
          this.getSchemes();
          this.$awn.success('Esquema de rodízio atualizado com sucesso.');
        })
        .catch(e => {
          this.$awn.alert('Erro ao atualizar esquema de rodízio.');
        })
        .finally(() => {
          this.add_scheme = false;
        });
    },

    save() {
      if (this.scheme.id) this.update();
      else this.create();
    },

    create() {
      if (!this.validateScheme('create')) return;
      this.licensePlateRotationSchemaController
        .create(this.scheme)
        .then(res => {
          this.getSchemes();
          this.$awn.success('Esquema de Rodízio cadastrado com sucesso.');
        })
        .catch(e => {
          this.$awn.alert('Erro ao cadastrar esquema de rodízio.');
        })
        .finally(() => {
          this.add_scheme = false;
        });
    },

    openAddModel() {
      this.clearFields();
      this.add_scheme = true;
    },

    clearFields() {
      this.scheme = {};
      this.sunday = [null];
      this.monday = [null];
      this.tuesday = [null];
      this.wednesday = [null];
      this.thursday = [null];
      this.friday = [null];
      this.saturday = [null];
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.plate-buttons {
  display: flex;
  flex: 1;
  flex-direction: row;
}
.plate_select {
  margin-top: 0;
  padding-top: 0;
}
.week_day {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
}
.margin_padding_0 {
  margin: 0;
  padding: 0;
}
label {
  margin-bottom: 0;
}
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
